import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { BlogDetailsViewModel } from 'src/app/view-models/blog-details.viewmodel';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent extends BaseComponent<BlogDetailsViewModel>implements OnInit {

  constructor(commonService: CommonService, logService: LogHandlerService) {
   super(commonService, logService)
   }

  ngOnInit(): void {
  }

}
